import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { ThemeProvider, CssBaseline } from '@mui/material';
import darkTheme from './theme';

// Page components
import Login from './pages/Login';
import Register from './pages/Register';
import Dashboard from './pages/Dashboard';
import FormPage from './pages/FormPage';
import ViewAllPage from './pages/ViewAllPage';
import DataPage from './pages/DataPage';
import VerifyEmail from './pages/VerifyEmail';

// Form components for editing
import RentForm from './components/forms/RentForm';
import InsuranceForm from './components/forms/InsuranceForm';
import BillForm from './components/forms/BillForm';
import LoanForm from './components/forms/LoanForm';

function App() {
  return (
    <ThemeProvider theme={darkTheme}>
      <CssBaseline />
      <Router>
        <Routes>
          {/* Authentication routes */}
          <Route path="/" element={<Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/verify-email" element={<VerifyEmail />} />
          {/* Main application routes */}
          <Route path="/dashboard" element={<Dashboard />} />
          <Route path="/form" element={<FormPage />} />
          <Route path="/view-all/:category?/:id?" element={<ViewAllPage />} />
          <Route path="/data" element={<DataPage />} />
          {/* Edit routes for form components */}
          <Route path="/edit-rent/:id" element={<RentForm />} />
          <Route path="/edit-insurance/:id" element={<InsuranceForm />} />
          <Route path="/edit-bill/:id" element={<BillForm />} />
          <Route path="/edit-loan/:id" element={<LoanForm />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;